export const NONE = 1;
export const INIT = 2;
export const PHONE_CONFIRMATION = 3;
export const EMAIL_SENT = 4;
export const SUCCESS = 5;



// WEBPACK FOOTER //
// ./js/constants/JoinStage.js